import { render, staticRenderFns } from "./logisticsTrace.vue?vue&type=template&id=61f0655e&scoped=true&"
import script from "./logisticsTrace.vue?vue&type=script&lang=js&"
export * from "./logisticsTrace.vue?vue&type=script&lang=js&"
import style0 from "./logisticsTrace.vue?vue&type=style&index=0&id=61f0655e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f0655e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61f0655e')) {
      api.createRecord('61f0655e', component.options)
    } else {
      api.reload('61f0655e', component.options)
    }
    module.hot.accept("./logisticsTrace.vue?vue&type=template&id=61f0655e&scoped=true&", function () {
      api.rerender('61f0655e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/constructionEquipmentMgr/stockMgr/mobile/components/logisticsTrace.vue"
export default component.exports